import {
  BasePageModel,
  basePageToLocal,
  basePageToServer
} from './index';

export enum PromptType {
  confirm = 'confirm',
  prompt = 'prompt',
  zeroPrompt = 'zero_prompt',
  multiValue = 'multi_value',
  multiValueMinException = 'multi_value_min_exception',
  multiValueMaxException = 'multi_value_max_exception',
  error = 'error',
  inform = 'inform',

  confirmYes = 'confirm_yes',
  confirmNo = 'confirm_no',
  promptAnswer = 'prompt_answer',
  booleanYes = 'boolean_yes',
  booleanNo = 'boolean_no',
  multiNo = 'multi_value_no',
  frameQuery = 'frame_query',
  dontCare = 'dont_care'
}

export interface PromptInfo extends BasePageModel {
  prompt: string;
  promptType: PromptType;
  masterSelf?: PromptInfo;
}

export const PromptOwnerType = {
  intent: 'intent',
  composite: 'composite',
  entity: 'entity',
  attribute: 'attribute',
  confirm: 'confirm',
  valueCheck: 'check',
  dialogAct: 'dialog_act',
  application: 'application',
  suggestion: 'suggestion',
  filtering: 'filtering'
};

export function promptInfoToLocal(res: any): PromptInfo {
  return {
    ...basePageToLocal(res),
    prompt: res.prompt,
    promptType: res.prompt_type,
    masterSelf: res.master_self && promptInfoToLocal(res.master_self)
  };
}

export function promptInfoToServer(data: PromptInfo) {
  const payload: any = {
    ...basePageToServer(data),
    id: data.id,
    agent_id: data.agentId,
    frame_id: data.frameId,
    owner_id: data.ownerId,
    owner_type: data.ownerType,
    prompt: data.prompt,
    prompt_type: data.promptType,
    to_be_deleted: data.toBeDeleted
  };

  if (!payload.id.length) {
    delete payload.id;
  }

  return payload;
}

